// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import numeral from 'numeral'
import VueMoment from 'vue-moment'
import SocialSharing from 'vue-social-sharing'

import 'bulma/css/bulma.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bulma-tagsinput/dist/css/bulma-tagsinput.min.css'
require('./assets/css/custom.css')
require('./assets/css/vue-plyr.css')
require('./assets/css/vue-multiselect.min.css')
require('./assets/photoswipe/dist/photoswipe.css')
require('./assets/photoswipe/dist/default-skin/default-skin.css')

Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0");
});

Vue.use(VueMoment)
Vue.use(SocialSharing)


Vue.prototype.$appUrl                     = location.origin == 'http://localhost:8080' ? 'http://localhost:7000' : 'https://unetworld.com';
Vue.prototype.$bidStatusCancel            = 0
Vue.prototype.$bidStatusActive            = 1
Vue.prototype.$bidStatusWin               = 2
Vue.prototype.$bidStatusLose              = 3
Vue.prototype.$bidStatusLoseToOtherUser   = 4
Vue.prototype.$bidStatusUnsold            = 5
Vue.prototype.$bidStatusUnderNegotiations = 6

Vue.prototype.$bidIsAutomatic = 1;
Vue.prototype.$bidIsReal      = 2;

Vue.prototype.$userTypeIndividual   = 0;
Vue.prototype.$userTypeProfessional = 1;
Vue.prototype.$userTypeOther        = 2;

Vue.prototype.$carsSectionInJapan = 1;
Vue.prototype.$carsSectionBooked = 2;
Vue.prototype.$carsSectionOnTheWay = 3;
Vue.prototype.$carsSectionArrived = 4;
Vue.prototype.$carsSectionAllCars = 5;

Vue.prototype.$currencyIsJpy = 1;
Vue.prototype.$currencyIsUsd = 2;

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js